import { load } from './_load.js';
/*
	Session Storageにデータがなければローカルのjsonから全件取得
*/

export let fetchPost = {
	get: function( pageType ){
		return new Promise((resolve, reject) =>{
			let data 			= [];
			let sessionStorageData;
			let url 			= "";
			let sessionKeyName 	= "";
			let summaryData = "";
			if( pageType === "works" ){
				sessionKeyName 	= "worksSummary";
				summaryData 	= sessionStorage.getItem('worksSummary');
				url = "/assets/json/works.json";
			}else if( pageType === "magazine" ){
				sessionKeyName 	= "magazineSummary";
				summaryData 	= sessionStorage.getItem('magazineSummary');
				summaryData = null;
				url = "/assets/json/magazine.json";
			}else if( pageType === "news" ){
				sessionKeyName 	= "newsSummary";
				summaryData 	= sessionStorage.getItem('newsSummary');
				summaryData = null;
				url = "/assets/json/news.json";
			}
			if( summaryData ){ //セッションストレージにデータが既にある
				data = JSON.parse( summaryData );
				resolve(data);
				//console.log("%cdata from Local","color:white; background-color: #3AA6B9; padding:2px; border-radius:2px;", data);
			}else{ //セッションストレージにデータがない場合
				//console.log(url);
				load.getLocalJson(url).then( (res) => {
					data = res;
					//console.log("res:", data);
					let jsonData = JSON.stringify(res);
					sessionStorage.setItem(sessionKeyName, jsonData);
					resolve(data);
					//console.log("%cdata from load json","color:white; background-color: #3AA6B9; padding:2px; border-radius:2px;", data);
				});
			}
		});
	},
	getWedCafe: function(){
		return new Promise((resolve, reject) =>{
			/*
			sessionKeyName 	= "wedcafe";
			summaryData 	= sessionStorage.getItem('wedcafe');
			url 			= "/assets/json/wedcafe.json";
			*/
			load.getLocalJson("/assets/json/wedcafe.json").then( (wedcafe) => {
				let wedcafeData = wedcafe;
				resolve(wedcafeData);
			});
		});
	},
	getWeCafeAllPost: function(){
		return new Promise((resolve, reject) =>{
			/*
			sessionKeyName 	= "wedcafe";
			summaryData 	= sessionStorage.getItem('wedcafe');
			url 			= "/assets/json/wedcafe.json";
			*/
			load.getLocalJson("/assets/json/magazine_wednesday_kitchen.json").then( (wedcafe) => {
				let wedcafeData = wedcafe;
				resolve(wedcafeData);
			});
		});
	},
	filterByCategory: function( data, category ){
		//フィルター: 全データからカテゴリでフィルターしたものを返す
		let filteredData = data.filter( function(item) {
			if( item.categories ){
				return item.categories.some( function(cat){
					return cat.slug === category;
				});
			}
			return false
		});
		//console.log("%c" + "filtered: " + category ,"color:white; background-color: #EB5B00; padding:2px; border-radius:2px;", filteredData);
		return filteredData;
	},
	filterByTag: function( data, tag ){
		//フィルター: 全データからタグでフィルターしたものを返す
		let filteredData = data.filter( function(item) {
			if( item.tags ){
				return item.tags.some( function(cat){
					return cat.slug === tag;
				});
			}
			return false
		});
		//console.log("%c" + "filtered: " + category ,"color:white; background-color: #EB5B00; padding:2px; border-radius:2px;", filteredData);
		return filteredData;
	},
	getDataByPage: function(data, page, count){
		//ページャー: 現在のページによって全データから該当データを抜き出して返す
		let start 	= page*count;
		let end 	= start + count;
		const slicedData = data.slice( start, end );
		//console.log(start, end, slicedData);
		return slicedData;
	}
}